import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BarChart } from '@/components/charts/bar-chart';
import { SimulationRunContainerTeuData } from '@/routes/(app)/(scenarios)/(simulation)/simulation.types';
import { mapContainerTeuChartData } from '@/routes/(app)/(scenarios)/(simulation)/simulation.utils';

interface SimulationContainersTeuChartProps {
  data: SimulationRunContainerTeuData;
}
export const SimulationContainersTeuChart: FC<
  SimulationContainersTeuChartProps
> = ({ data }) => {
  const { t } = useTranslation();
  const chartData = useMemo(() => mapContainerTeuChartData(data), [data]);
  return (
    <BarChart
      className='col-span-1'
      title={t('simulation.charts.containersTeu.title')}
      data={chartData}
      indexKey='date'
      tabs={[{ key: 'teu', label: t('general.teu') }]}
      showTabTotals={false}
      fields={[
        {
          key: 'import',
          label: t('general.import'),
          color: 'indigo',
          stackId: 'a',
        },
        {
          key: 'export',
          label: t('general.export'),
          color: 'orange',
          stackId: 'a',
        },
        {
          key: 'transshipment',
          label: t('general.transshipment'),
          color: 'violet',
          stackId: 'a',
        },
      ]}
    />
  );
};
